<template>
    <el-card class="box-card mt15">
        <template v-if="status > 1" slot='header'>
            <div>
                <span>登记详情</span>
            </div>
        </template>
        <template v-if="status > 1">
            
            <!-- 用于显示的信息 start -->
            <ly-table 
                :head="customerConfig.head" 
                :data="data" 
                :config="customerConfig.config">
            </ly-table>
            <!-- 用于显示的信息 end -->
        </template>
        <!-- 用于设置的列表 start -->
        <ly-product-table 
            ref="productTable"
            :thead-config="productConfig"
            v-model="list"
            v-else>
        </ly-product-table>
        <!-- 用于设置的列表 end -->
        
    </el-card>
</template>
<script>

    import LyTable from '@c/table'
    import LyProductTable from '@c/product-table'
    export default {
        components: {
            LyTable,
            LyProductTable
        },
        props: {
            status: [String, Number], // 单据的状态
            data: {
                type: [Array, Object],
                default: () => []
            }
        },
        watch: {
            data: {
                immediate: true,
                handler () {
                    if (this.status <= 1) {
                        this.list = this.data
                        this.$nextTick(() => {
                            this.$refs['productTable'].replaceProductList(this.data)
                        })
                    }
                }
            }
        },
        data () {
            return {
                list: [],
                // 新增时的配置
                productConfig: [{
                    prop: 'customer',
                    label: '客户编码',
                    width: 100,
                    json: {
                        width: '471px',
                        api: 'api/customer',
                        prop: 'customer_account',
                        fields: [{
                            label: '客户编码',
                            prop: 'customer_account',
                            width: 200
                        }, {
                            label: '客户名称',
                            prop: 'customer_name',
                            width: 270
                        }]
                    },
                    component: 'LyAutoSearch'
                }, {
                    prop: 'customer',
                    label: '客户名称',
                    width: 200,
                    json: {
                        width: '471px',
                        api: 'api/customer',
                        prop: 'customer_name',
                        fields: [{
                            label: '客户编码',
                            prop: 'customer_account',
                            width: 200
                        }, {
                            label: '客户名称',
                            prop: 'customer_name',
                            width: 270
                        }]
                    },
                    component: 'LyAutoSearch'
                }, {
                    prop: 'huikuan_amount',
                    label: '实收/实退金额',
                    width: 100,
                    component: 'LyInputNumber'
                }, {
                    prop: 'shouxufei',
                    label: '手续费(非必填)',
                    width: 100,
                    component: 'LyInputNumber'
                }, {
                    prop: 'weidu_id',
                    label: '核算纬度',
                    width: 80,
                    component: 'LySelect',
                    json: {
                        defOne: true,
                        all: false,
                        api: "api/accountingDimension"
                    }
                }, {
                    prop: 'tuanduimingzi',
                    label: '团队名称',
                    width: 80,
                    component: 'ElInput'
                }, {
                    prop: 'wlye',
                    label: '往来余额',
                    width: 70,
                    json: {
                        api: 'api/wanglaiz',
                        showkey: 'amount',
                        watch:'customer',
                        watch2: 'weidu_id'
                    },
                    component: 'LyAutoText'
                }, {
                    prop: 'employee_id',
                    label: '单据业务员',
                    width: 150,
                    component: 'LySelect',
                    json: {
                        defOne: false,
                        all: false,
                        api: "api/employee"
                    }
                }, {
                    prop: 'zhaiyao',
                    label: '摘要',
                    width: 300,
                    component: 'ElInput'
                }],
                // 显示时的配置
                customerConfig: {
                    config: {
                        isNumber: true
                    },
                    head: [
                        {
                            "prop": "customer_code",
                            "label": "客户编码"
                        }, {
                            "prop": "customer_name",
                            "label": "客户名称"
                        }, {
                            "prop": "amount",
                            "label": "实收/实退金额",
                            "width": 150
                        }, {
                            "prop": "shouxufei",
                            "label": "手续费"
                        }, {
                            "prop": "weidu_name",
                            "label": "核算纬度"
                        }, {
                            "prop": "tuanduimingzi",
                            "label": "团队名称"
                        }, {
                            "prop": "employee_name",
                            "label": "单据业务员"
                        }, {
                            "prop": "zhaiyao",
                            "label": "备注"
                        }
                    ]
                }
            }
        },
        methods: {
            /**
             * 数据验证
             */
            validate () {
                if (this.list.length > 0) {
                    let msg = this.validateCustomer(this.list);
                    if (this.validateCustomer(this.list).length) {
                        this.$message({
                            message: msg,
                            type: 'warning'
                        })
                        return false
                    } else {
                        return true
                    }
                } else {
                    this.$message({
                        message: '请填入登记信息',
                        type: 'warning'
                    })
                    return false
                }
            },
            /**
             * 获得数据
             */
            getData () {
                return {
                    register: this.list
                }
            },
            /**
             * 验证登记信息
             */
            validateCustomer (arr) {
                let msg = '' // 提示的信息
                let index = -1 // 记录有问题的行
                for (let i in arr) {
                    let row = arr[i]
                    if (!row.customer || !row.customer.customer_account) {
                        msg += '"客户编码"'
                    }
                    if (!row.customer || !row.customer.customer_name) {
                        msg += '"客户名称"'
                    }
                    if (row.huikuan_amount === '') {
                        msg += '"实收/实退金额"'
                    }
                    if (msg.length > 0) {
                        index = i
                        break;
                    }
                }
                if (index >= 0) {
                    msg = '第' + parseInt(parseInt(index) + 1) + '行还未选择\n' + msg
                }
                return msg
            }
        }
    }
</script>